import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
  timeout: 30000,
});

let refreshing = null;
const NO_RETRY = ["/auth/refresh", "/auth/login", "/auth/logout", "/auth/signup", "/auth/reset-password", "/auth/forgot-password"];

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (
      error.response?.status === 401 &&
      !original._retry &&
      !NO_RETRY.some((p) => original.url.includes(p))
    ) {
      original._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
        await refreshing;
        return api(original);
      } catch {
        // refresh failed — fall through to the original 401
      }
    }
    return Promise.reject(error);
  }
);

export default api;
